module.exports = __webpack_public_path__ + "static/media/tree_8.b0698b10.jpg";